const MAX_CONCURRENT_AUTO_BLINKS = 1
let activeAutoBlinkCount = 0
const queue: Array<() => void> = []

export function acquireAutoBlinkSlot(): boolean {
    if (activeAutoBlinkCount >= MAX_CONCURRENT_AUTO_BLINKS) {
        return false
    }
    activeAutoBlinkCount++
    return true
}

export function releaseAutoBlinkSlot() {
    activeAutoBlinkCount--
    queue.shift()?.()
}

export function enqueueAutoBlink(start: () => void) {
    queue.push(start)
}

export function dequeueAutoBlink(start: () => void) {
    const index = queue.indexOf(start)
    if (index !== -1) {
        queue.splice(index, 1)
    }
}
